(function () {
  if (window.AsIfAvailabilityCalendar) return;
  var requestSerial = 0;
  function mount(root) {

  var title = root.querySelector('#calTitle');
  var grid = root.querySelector('#calGrid');
  var legend = root.querySelector('.cal-legend');
  var status = root.querySelector('#calStatus');
  var endpoint = grid.getAttribute('data-availability-url') || '';
  var months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var formatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' });
  var cache = {}, pending = {}, cancellations = {}, renderId = 0, destroyed = false;
  var startedAt = Date.now(), firstDrawn = false, firstReady = false;
  var storagePrefix = 'asif-availability-v2:' + endpoint + ':';
  function today() {
    var parts = formatter.formatToParts(new Date()), result = {};
    parts.forEach(function (part) { result[part.type] = part.value; });
    return result.year + '-' + result.month + '-' + result.day;
  }
  var initial = today(), year = Number(initial.slice(0, 4)), month = Number(initial.slice(5, 7));
  function valid(data, y) {
    var updated = Date.parse(data && data.updatedAt);
    return !!data && data.ok === true && data.year === y && data.month === 1 && data.months === 12 &&
      Number.isFinite(updated) && Date.now() - updated < 60000 && updated - Date.now() < 5000 &&
      Array.isArray(data.busyDates) && data.busyDates.length <= 366 && data.busyDates.every(function (day) {
        if (typeof day !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(day) || day.slice(0, 4) !== String(y)) return false;
        var m = Number(day.slice(5, 7)), d = Number(day.slice(8));
        return m >= 1 && m <= 12 && d >= 1 && d <= new Date(Date.UTC(y, m, 0)).getUTCDate();
      });
  }
  function fresh(y) {
    if (!cache[y]) {
      try { cache[y] = JSON.parse(sessionStorage.getItem(storagePrefix + y)); } catch (error) {}
    }
    if (valid(cache[y], y)) return cache[y];
    delete cache[y];
    try { sessionStorage.removeItem(storagePrefix + y); } catch (error) {}
    return null;
  }
  function invalidate(y) {
    delete cache[y];
    try { sessionStorage.removeItem(storagePrefix + y); } catch (error) {}
  }
  function unavailable(error) {
    legend.hidden = true;
    status.hidden = true;
    grid.setAttribute('data-availability-error', error.message);
    grid.setAttribute('aria-busy', 'false');
    grid.innerHTML = '<div class="cal-loading" role="status" style="flex-direction:column;gap:12px;color:#8b1e1e;text-align:center">Verfügbarkeit derzeit nicht abrufbar.<button type="button" class="side-btn" data-cal-retry>Erneut versuchen</button></div>';
  }
  function draw(y, m, data) {
    var busy = data ? new Set(data.busyDates) : null;
    var offset = (new Date(Date.UTC(y, m - 1, 1)).getUTCDay() + 6) % 7;
    var maxDay = new Date(Date.UTC(y, m, 0)).getUTCDate();
    var td = today(), html = '';
    for (var i = 0; i < offset; i++) html += '<div class="cal-day empty" aria-hidden="true"></div>';
    for (var day = 1; day <= maxDay; day++) {
      var date = y + '-' + String(m).padStart(2, '0') + '-' + String(day).padStart(2, '0');
      var state = busy ? (busy.has(date) ? 'booked' : 'free') : 'unknown';
      var label = busy ? (busy.has(date) ? 'Gebucht' : 'Verfügbar') : 'Verfügbarkeit wird geladen';
      var classes = 'cal-day ' + (date < td ? 'past' : state) + (date === td ? ' today' : '');
      html += '<div class="' + classes + '" aria-label="' + day + '. ' + months[m - 1] + ' ' + y + ': ' + label + '">' + day + '</div>';
    }
    grid.innerHTML = html;
    grid.setAttribute('data-availability-error', '');
    grid.setAttribute('aria-busy', data ? 'false' : 'true');
    legend.hidden = !data;
    status.hidden = !!data;
    if (!firstDrawn) {
      firstDrawn = true;
      grid.setAttribute('data-calendar-layout-ms', String(Date.now() - startedAt));
    }
    if (data && !firstReady) {
      firstReady = true;
      grid.setAttribute('data-availability-ready-ms', String(Date.now() - startedAt));
    }
  }
  function load(y, refresh) {
    if (!refresh) {
      var stored = fresh(y);
      if (stored) return Promise.resolve(stored);
    }
    if (pending[y]) return pending[y];
    pending[y] = new Promise(function (resolve, reject) {
      if (!/^https:\/\/script\.google\.com\/macros\/s\/[a-zA-Z0-9_-]+\/exec$/.test(endpoint)) { reject(new Error('unavailable')); return; }
      var callback = 'asifCalendar_' + Date.now() + '_' + (++requestSerial);
      var script = document.createElement('script'), timer;
      function cleanup() { clearTimeout(timer); script.remove(); delete window[callback]; delete cancellations[callback]; }
      function fail(reason) { cleanup(); invalidate(y); reject(new Error(reason)); }
      window[callback] = function (data) {
        if (!valid(data, y)) { fail(data && data.ok === false ? 'source' : 'data'); return; }
        cleanup();
        cache[y] = data;
        try { sessionStorage.setItem(storagePrefix + y, JSON.stringify(data)); } catch (error) {}
        resolve(data);
      };
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.onerror = function () { fail('network'); };
      script.src = endpoint + '?year=' + y + '&month=1&span=12&callback=' + callback;
      timer = setTimeout(function () { fail('timeout'); }, 35000);
      cancellations[callback] = function () { fail('aborted'); };
      document.head.appendChild(script);
    }).finally(function () { delete pending[y]; });
    return pending[y];
  }
  function render(refresh) {
    if (destroyed) return;
    var y = year, m = month, id = ++renderId;
    title.textContent = months[m - 1] + ' ' + y;
    var stored = fresh(y);
    draw(y, m, stored);
    if (stored && !refresh) return;
    status.hidden = false;
    grid.setAttribute('aria-busy', 'true');
    load(y, refresh).then(function (data) {
      if (id === renderId) draw(y, m, data);
    }).catch(function (error) { if (id === renderId) unavailable(error); });
  }
  function move(delta) {
    var d = new Date(Date.UTC(year, month - 1 + delta, 1));
    var nextYear = d.getUTCFullYear(), currentYear = Number(today().slice(0, 4));
    if (nextYear < currentYear - 1 || nextYear > currentYear + 3) return;
    year = nextYear;
    month = d.getUTCMonth() + 1;
    render(false);
  }
  var api = { prev: function () { move(-1); }, next: function () { move(1); }, retry: function () { render(true); }, destroy: destroy };
  function onAction(event) {
    var button = event.target.closest('[data-cal-prev],[data-cal-next],[data-cal-retry]');
    if (!button || !root.contains(button)) return;
    if (button.hasAttribute('data-cal-prev')) api.prev();
    else if (button.hasAttribute('data-cal-next')) api.next();
    else api.retry();
  }
  function onVisibility() { if (!document.hidden) render(false); }
  root.addEventListener('click', onAction);
  document.addEventListener('visibilitychange', onVisibility);
  var interval = setInterval(function () { if (!document.hidden) render(true); }, 60000);
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    renderId++;
    clearInterval(interval);
    root.removeEventListener('click', onAction);
    document.removeEventListener('visibilitychange', onVisibility);
    Object.keys(cancellations).forEach(function (key) { cancellations[key](); });
  }
  render(false);
  return api;
  }
  var pageInstances = new Map();
  function scanPages() {
    pageInstances.forEach(function (api, root) {
      if (!root.isConnected) { api.destroy(); pageInstances.delete(root); }
    });
    document.querySelectorAll('.cal-page:not(.cal-page--widget)').forEach(function (root) {
      if (pageInstances.has(root)) return;
      var api = mount(root);
      pageInstances.set(root, api);
      window.asifCal = api;
    });
  }
  window.AsIfAvailabilityCalendar = { mount: mount };
  document.addEventListener('asif:page', scanPages);
  document.addEventListener('asif:page:start', function () {
    pageInstances.forEach(function (api) { api.destroy(); });
    pageInstances.clear();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanPages, { once: true });
  else scanPages();
})();
